// 导出该模块（云桌面管理）state、actions、mutations
import actions from './actions'
import systemSettingMng from './metaData/sysSetForm.js'
export default {
  state: systemSettingMng,
  actions
}
